import { useNavigate } from "react-router-dom"
import { TextBtn } from "../../shared";
import IssuedWellnessTicket from "../IssuedWellnessTicket";
import CunstomAbleCarousel from "../../shared/carousel/cunstomAbleCarousel";
import { useEffect, useRef, useState } from "react";

interface IProps {
    myIssuedWellnessTicketList: any[] | IIssuedWellnessTicketBasicResponseV2[];
    focusIssuedWellnessTicketId?: number;
}
const IssuedWellnessTicketCarousel = ({ myIssuedWellnessTicketList, focusIssuedWellnessTicketId }: IProps) => {
    const navigate = useNavigate();
    const ref = useRef<HTMLDivElement>(null)
    const [firstWidth, setFirstWidth] = useState<number>(320);

    useEffect(() => {
        if (ref.current) {
            setFirstWidth(ref.current.getBoundingClientRect().width)
        }
    }, [ref.current])

    const focusIndex = focusIssuedWellnessTicketId == null
        ? -1
        : myIssuedWellnessTicketList.findIndex((issuedWellnessTicket) => issuedWellnessTicket.id === focusIssuedWellnessTicketId);

    return <>
        <div className="title/t1" style={{ paddingInline: "20px", marginBlock: '20px' }}>정기권</div>
        {myIssuedWellnessTicketList.length === 0
            ? <div style={{
                backgroundColor: "var(--secondarys100)", borderRadius: "var(--radius4)",
                margin: '20px 20px 24px',
                padding: '61px 0',
                textAlign: 'center'
            }}>
                <div className="body/b2 secondary/s600">
                    보유하신 정기권이 없습니다
                </div>
                <TextBtn type='underline' textDecorationColor='' style={{ color: 'var(--secondarys800)', marginTop: 8 }} onClick={() => navigate('/wellness-ticket-group')} icon={false}>
                    정기권 구매하기
                </TextBtn>
            </div>
            : <div>
                {myIssuedWellnessTicketList.length === 1
                    ? myIssuedWellnessTicketList.map((issuedWellnessTicket, idx) =>
                        <div key={issuedWellnessTicket.id} ref={idx === 0 ? ref : null} style={{ cursor: 'pointer', width: 'calc(100vw - 11vw)', maxWidth: 'calc(480px - 11vw)', paddingLeft: '5.5vw' }} onClick={() => navigate(`/issued-wellness-ticket/${issuedWellnessTicket.id}`)}>
                            <IssuedWellnessTicket issuedWellnessTicket={issuedWellnessTicket} />
                        </div>)
                    : <CunstomAbleCarousel firstWidth={firstWidth} dataLength={myIssuedWellnessTicketList.length} initialIndex={focusIndex >= 0 ? focusIndex : undefined}>
                        {myIssuedWellnessTicketList.map((issuedWellnessTicket, idx) =>
                            <div key={issuedWellnessTicket.id} ref={idx === 0 ? ref : null} style={{ cursor: 'pointer', width: 'calc(100vw - 11vw)', maxWidth: 'calc(480px - 11vw)', paddingLeft: myIssuedWellnessTicketList.length === 1 ? '5.5vw' : '3.3vw' }} onClick={() => navigate(`/issued-wellness-ticket/${issuedWellnessTicket.id}`)}>
                                <IssuedWellnessTicket issuedWellnessTicket={issuedWellnessTicket} />
                            </div>
                        )}
                    </CunstomAbleCarousel>}
            </div >
        }
    </>
}

export { IssuedWellnessTicketCarousel }